import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { IoMdArrowDropdown } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";

export const Navbar = () => {
  const { keycloak, initialized } = useKeycloak();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();


  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="fixed z-50 bg-green-900 text-white shadow-md w-full">
      <nav className="container mx-auto flex items-center justify-between px-3 md:px-6 py-6">
        {/* Logo */}
        <Link to="/" className="text-3xl font-bold tracking-wide">
          Acker<span className="text-green-300">plus</span>
        </Link>

        {/* Hamburger Button (Mobile) */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-white focus:outline-none"
        >
          {menuOpen ? <IoMdClose size={30} /> : <GiHamburgerMenu size={30} />}
        </button>

        {/* Desktop Nav */}
        <ul className="hidden md:flex gap-6 items-center text-lg font-medium">
          <li>
            <Link to="/" className="hover:text-green-300 transition-colors py-2">
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/subscription"
              className="hover:text-green-300 transition-colors py-2"
            >
              Preise
            </Link>
          </li>
          {initialized && keycloak.authenticated && (
            <li>
              <Link
                to="/map"
                className="hover:text-green-300 transition-colors py-2"
              >
                Feldkalender
              </Link>
            </li>
          )}
          <li>
            <Link
              to="/contact"
              className="hover:text-green-300 transition-colors py-2 capitalize"
            >
              Kontakt
            </Link>
          </li>
        </ul>

        {/* Desktop Right Side */}
        <div className="hidden md:flex items-center gap-4 text-lg">

          {!keycloak.authenticated && (
            <>
              <button
                onClick={() => keycloak.register()}
                className="px-5 py-2.5 rounded-lg bg-gray-600 hover:bg-gray-700 transition-colors"
              >
                Registrieren
              </button>
              <button
                onClick={() => keycloak.login()}
                className="px-5 py-2.5 rounded-lg bg-green-600 hover:bg-green-700 transition-colors"
              >
                Login
              </button>
            </>
          )}

          {keycloak.authenticated && (
            <div className="relative">
              <button
                onClick={toggleDropdown}
                className="flex items-center gap-1 font-medium hover:text-green-300"
              >
                {keycloak.tokenParsed?.preferred_username}{" "}
                <IoMdArrowDropdown size={20} />
              </button>
              {dropdownOpen && (
                <ul className="absolute right-0 mt-2 w-44 rounded-lg bg-white text-black shadow-lg">
                  <li>
                    <button
                      onClick={() => navigate("/profile")}
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                    >
                      Profil
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => keycloak.logout()}
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                    >
                      Abmelden
                    </button>
                  </li>
                </ul>
              )}
            </div>
          )}
        </div>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-green-900 px-6 py-4 space-y-4">
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            className="block text-lg font-medium py-2 hover:text-green-300"
          >
            Home
          </Link>
          <Link
            to="/subscription"
            onClick={() => setMenuOpen(false)}
            className="block text-lg font-medium py-2 hover:text-green-300"
          >
            Preise
          </Link>
          {keycloak.authenticated && (
            <Link
              to="/map"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-medium py-2 hover:text-green-300"
            >
              Feldkalender
            </Link>
          )}
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="block text-lg font-medium py-2 hover:text-green-300 capitalize"
          >
            Kontakt
          </Link>

          <div className="h-px w-full bg-gray-300 my-6"></div>
          {!keycloak.authenticated ? (
            <>
              <Link
                to={keycloak.createRegisterUrl()}
                onClick={() => setMenuOpen(false)}
                className="block px-5 py-2.5 rounded-lg bg-gray-600 hover:bg-gray-700 transition-colors"
              >
                Registrieren
              </Link>
              <button
                onClick={() => {
                  setMenuOpen(false);
                  keycloak.login();
                }}
                className="block w-full text-left px-5 py-2.5 rounded-lg bg-green-600 hover:bg-green-700 transition-colors"
              >
                Login
              </button>
            </>
          ) : (
            <>
              <Link
                to="/profile"
                onClick={() => setMenuOpen(false)}
                className="block text-lg font-medium py-2 hover:text-green-300"
              >
                Profil
              </Link>

              <button
                onClick={() => {
                  setMenuOpen(false);
                  keycloak.logout();
                }}
                className="block w-full text-left px-5 py-2.5 rounded-lg bg-green-600 hover:bg-green-700 transition-colors"
              >
                Abmelden
              </button>
            </>
          )}
        </div>
      )}
    </header>
  );

};
